module.exports = __webpack_public_path__ + "img/rogers-and-sons.621f0fec.png";